import kalkulatorTemplate from './kalkulator.pug';
import { MEGTAKARITAS_TIPUS, JARADEK_TIPUS } from './lib/tipus-base';
const KALKULACIO_METODUSOK = {
	[MEGTAKARITAS_TIPUS] : 'megtakaritasKalkulacio',
	[JARADEK_TIPUS]: 'jaradekKalkulacio'
}
export const KalkulatorComponent = {
	template: kalkulatorTemplate(),
	transclude: {
		tooltipFormContent: 'tooltipFormContent',
		tooltipResultContent: 'tooltipResultContent'
	},
	bindings: {
		tipus: '@'
	},
	controller: class KalkulatorController {
		constructor(KalkulatorService, $timeout, $rootScope) {
			'ngInject';
			this.kalkulatorService = KalkulatorService;
			this.$timeout = $timeout;
			this.$rootScope = $rootScope;
		}
		$onInit() {
			this.init();
		}
		init() {
			this.kalkulatorService.init().then((response) => {
				this.hozamok = response.hozamok;
				this.visszahivasIdok = response.visszahivasIdok;
				this.vegpontok = response.vegpontok;
			}).catch((err) => {
				this.$rootScope.$broadcast('serverError');
			});
		}
		resetResults() {
			this.eredmeny = null;
		}
		calculate(data) {
			let kalkulacioMetodus = KALKULACIO_METODUSOK[this.tipus];
			this.kalkulatorService[kalkulacioMetodus](data).then((response) => {
				this.eredmeny = response;
				this.$timeout(()=>{
					document.getElementById('kalkulator-result').scrollIntoView();
				});
			}).catch((err) => {
				this.$rootScope.$broadcast('serverError');
			});
		}
		sendVhk(data) {
			let dataToSend = Object.assign({}, data, { calculationId: this.eredmeny.id });
			this.kalkulatorService.sendVhk(dataToSend).then((response) => {
				this.vhkSuccess = true;
			}).catch((err) => {
				this.$rootScope.$broadcast('serverError');
			});
		}
	}
}



// WEBPACK FOOTER //
// ../source/application/kalkulator/kalkulator.component.js